import { Alert } from '@mui/material';

type Props = { message: string };

export const TableDataNotFound = ({ message }: Props) => {
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
};
